import MigrationPending from '@/components/ui/MigrationPending'

export default function ScanningIndex() {
  return <MigrationPending title="Scanning" subtitle="Warehouse scanning UI — migration pending" />
}

ScanningIndex.layout = MigrationPending.layout
